"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Class = void 0;
var Class = /** @class */ (function () {
    function Class(data) {
        if (data === void 0) { data = {}; }
        Object.assign(this, data);
        this.displayName = this.name || '';
    }
    Class.prototype.findTeacher = function (teacher) {
        var users = __spreadArray([this.owner], this.teachers, true).filter(function (item) { return item !== undefined; });
        return users.find(function (u) { return u.id === teacher.id; }) || teacher;
    };
    return Class;
}());
exports.Class = Class;
